module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/590e583abf28698083f3fd82f99f4fb7.png";